// alterado - revisado

import React, { useState } from 'react'

import useSingleton from '../../../business-components/useSingleton/useSingleton'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import {
    formataValor,
    formataPerc,
} from '../../../business-components/Formata/Formata'

import {
    DivOverflowX,
} from '../../../business-components/Div/Div'

import {
    GridContainer,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    CardGridDivBody,
} from '../../../business-components/Card/Card'

import {
    pesquisaList
} from '../../../business-rules/List/ListService'

import comparacaoCenariosEstudosItemList from '../../../business-rules/List/comparacaoCenariosEstudosItemList'

import {
    getInfoclientVersoes
} from '../cliente-form/ClienteService'

import {
    calculaGridItemCenariosEstudos,
    processaComparacaoCenariosEstudos,
} from './EstudoServiceComparacaoCenariosEstudos'

import {
    relatorioModoApresentacao,
} from './EstudoService'

import {
    CardGridEstudoPadrao,
} from './EstudoComp'



const EstudoFormComparacaoCenariosEstudos = ({ variaveisGlobais, values, handleSubmitAutomatico, estudo, linhaTipoLicenca, jsonConfiguracao,
    jsonPagina, jsonUsuario, jsonUsuarioAdmin, report, comparacaoCenariosEstudosTipo, simulacaoFinanceira, soCalculo, parte1, parte2 }) => {

    const [comparacaoCenariosEstudos, setComparacaoCenariosEstudos] = useState(false)
    const [comparacaoCenariosEstudosGrupo, setComparacaoCenariosEstudosGrupo] = useState(false)
    const [comparacaoCenariosEstudosItem, setComparacaoCenariosEstudosItemAux] = useState(false)

    useSingleton(async () => {

        if (!values.versoesInfoclient && comparacaoCenariosEstudosTipo === HARDCODE.comparacaoCenariosEstudosTipoEstudo) {

            values.versoesInfoclient = await getInfoclientVersoes(variaveisGlobais, values.id, values.versao, linhaTipoLicenca, jsonPagina,
                jsonUsuario, jsonUsuarioAdmin)
        }

        const { comparacaoCenariosEstudosAux, comparacaoCenariosEstudosGrupoAux, comparacaoCenariosEstudosItemAux } = 
            processaComparacaoCenariosEstudos(variaveisGlobais, values, handleSubmitAutomatico, estudo, report,
                jsonConfiguracao, comparacaoCenariosEstudosTipo, simulacaoFinanceira)

        setComparacaoCenariosEstudos(comparacaoCenariosEstudosAux)

        setComparacaoCenariosEstudosGrupo(comparacaoCenariosEstudosGrupoAux)
        
        setComparacaoCenariosEstudosItemAux(comparacaoCenariosEstudosItemAux)

        values.comparacaoCenariosEstudosItem = comparacaoCenariosEstudosItemAux
    })

    const GridItem = calculaGridItemCenariosEstudos(comparacaoCenariosEstudos, report)

    const ComparacaoCenariosEstudos = () => {

        const complemento = (linhaComparacaoCenariosEstudosItem) => {

            return (linhaComparacaoCenariosEstudosItem.complemento
                ?
                    ' ' + linhaComparacaoCenariosEstudosItem.complemento
                :
                    ''
            )
        }



        const paddingTabela = comparacaoCenariosEstudosItem.length > 45 ? '2px' : '5px'


        
        return (
            <table
                border='0'
                cellPadding='0'
                cellSpacing='0'
                width='100%'
                style={{
                    paddingTop:  report ? '2px' : '10px', // mudança da fonte: paddingTop: '10px'
                    paddingRight: report ? '2px' : '20px',
                    paddingLeft: report ? '2px' : '20px',
                    //paddingBottom: '10px',
                }}
            >
                <tbody>
                    {comparacaoCenariosEstudosGrupo?.map((grupo, indGrupo) => {
                        return ((!parte1 && !parte2) || (parte1 && indGrupo <= 2) || (parte2 && indGrupo > 2)) && (
                            <tr
                                key={indGrupo}
                            >
                                <td
                                    width='100%'
                                >
                                    <table
                                        className={report ? 'mt-1' : 'mt-2 mb-5'} // mudança da fonte: className={'mt-2 ' + (report ? '' : 'mb-5')}
                                        border='0'
                                        cellPadding='0'
                                        cellSpacing='0'
                                        width='100%'
                                        style={{
                                            padding: paddingTabela,
                                        }}
                                    >
                                        <tbody>
                                            <tr>
                                                <td
                                                    className={'text-white ' + (report ? 'text-13' : 'text-16')} // mudança da fonte: className={'text-white ' + (report ? 'text-14' : 'text-16')}
                                                    bgcolor={grupo.bgColorGrupo}
                                                    width={report ? '30%' : '25%'}
                                                    style={{
                                                        padding: paddingTabela,
                                                    }}
                                                >
                                                    {simulacaoFinanceira && grupo.descricaoSimulacaoFinanceira
                                                        ?
                                                            grupo.descricaoSimulacaoFinanceira
                                                        :
                                                            grupo.descricao
                                                    }
                                                </td>
                                                {comparacaoCenariosEstudos?.map((linhaCenarioEstudo, indCenarioEstudo) => {
                                                    return (
                                                        <td
                                                            key={indCenarioEstudo}
                                                            className={'font-medium ' + (report ? 'text-9' : 'text-12')}
                                                            align="center"
                                                            style={{
                                                                padding: paddingTabela,
                                                            }}
                                                        >
                                                            {<span dangerouslySetInnerHTML={{ __html: linhaCenarioEstudo.descricao}} />}
                                                        </td>
                                                    )
                                                })}
                                            </tr>
                                            {comparacaoCenariosEstudosItem?.map((item, ind) => {

                                                const linhaComparacaoCenariosEstudosItem =
                                                    pesquisaList(comparacaoCenariosEstudosItemList, 
                                                        item.idItem)

                                                return linhaComparacaoCenariosEstudosItem.grupo === grupo.id ? (
                                                    <tr
                                                        key={ind}
                                                        className={'text-white font-light ' + (report ? 'text-9' : 'text-11')} // mudança da fonte: className={'text-white font-light ' + (report ? 'text-9' : 'text-11')}
                                                        bgcolor={grupo.bgColorItem}
                                                    >
                                                        <td
                                                            className={'font-light-medium ' + (report ? 'text-9' : 'text-12')} // mudança da fonte: className={'font-light-medium ' + (report ? 'text-9' : 'text-12')}
                                                            width={report ? '13%' : '15%'}
                                                            style={{
                                                                border: '1px solid',
                                                                padding: paddingTabela,
                                                            }}
                                                        >
                                                            <span className='text-black'>{item.descricao}</span>
                                                        </td>
                                                        {item.valor?.map((linhaValor, indValor) => {
                                                            return (
                                                                <td
                                                                    key={indValor}
                                                                    width={report ? '13%' : '15%'}
                                                                    bgcolor={(indValor + 1) % 2 === 0 ? grupo.bgColorItem : grupo.bgColorItem2}
                                                                    align= 'center'
                                                                    style={{
                                                                        border: '1px solid',
                                                                        padding: paddingTabela,
                                                                    }}
                                                                >
                                                                    <span
                                                                        className={
                                                                            linhaValor >= 0 ||
                                                                            linhaValor === '-' ||
                                                                            ('' + linhaValor).substring(0, 1) === '+' ||
                                                                            linhaValor === LABEL.tracoXtraco
                                                                                ?
                                                                                    'text-black text-11'
                                                                                :
                                                                                    'text-error font-medium text-11'
                                                                            }
                                                                    >
                                                                        {linhaValor === '-' || ('' + linhaValor).substring(0, 1) === '+'
                                                                            ?
                                                                                linhaValor +
                                                                                    complemento(linhaComparacaoCenariosEstudosItem)
                                                                            :
                                                                                item.id === HARDCODE.comparacaoCenariosEstudosAporteEconomiaReceitaMensal
                                                                                    ?
                                                                                        formataPerc(linhaValor)
                                                                                    :
                                                                                        formataValor(linhaValor,
                                                                                            linhaComparacaoCenariosEstudosItem.decimais,
                                                                                                true/*linhaComparacaoCenariosEstudosItem.formataSemMoeda*/) +
                                                                                                    complemento(linhaComparacaoCenariosEstudosItem)
                                                                        }
                                                                    </span>
                                                                </td>
                                                            )
                                                        })}
                                                    </tr>
                                                )
                                                :
                                                (
                                                    <tr
                                                        key={ind}
                                                    />
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        )
    }

    return (
        comparacaoCenariosEstudos && comparacaoCenariosEstudosGrupo && comparacaoCenariosEstudosItem && GridItem && !soCalculo
            ?
                report
                    ?
                        <GridContainer>
                            <GridItem>
                                <ComparacaoCenariosEstudos/>
                            </GridItem>
                        </GridContainer>
                    :
                    simulacaoFinanceira
                        ?
                            <GridContainer>
                                <GridItem>
                                    <DivOverflowX>
                                        <ComparacaoCenariosEstudos/>
                                    </DivOverflowX>
                                </GridItem>
                            </GridContainer>
                        :
                            <CardGridEstudoPadrao
                                label={
                                    !relatorioModoApresentacao(values)
                                        ?
                                            comparacaoCenariosEstudosTipo === HARDCODE.comparacaoCenariosEstudosTipoEstudo
                                                ?
                                                    LABEL.comparacaoEstudos
                                                :
                                                    LABEL.comparacaoCenarios
                                        :
                                            HARDCODE.modoApresentacaoRelatorio
                                }
                                component={
                                    <GridContainer
                                        className='justify-center'
                                    >
                                        <GridItem12>
                                                <GridContainer
                                                    className='mt-1'
                                                >
                                                    <GridItem>
                                                        <CardGridDivBody>
                                                            <DivOverflowX>
                                                                <ComparacaoCenariosEstudos/>
                                                            </DivOverflowX>
                                                        </CardGridDivBody>
                                                    </GridItem>
                                                </GridContainer>
                                        </GridItem12>
                                    </GridContainer>
                                }
                                overflowX={false}
                            />
            :
                ''
    )
}

export default EstudoFormComparacaoCenariosEstudos